// A lightweight fetch client with base URL, default headers, timeout, AbortController, and retries

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const API_KEY = process.env.REACT_APP_API_KEY || 'aEP9vAP1shyS3sjWW5LI1Nw1Q1LGQHdgVEExCvGJ';

function resolveUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  if (pathOrUrl.startsWith('/api')) {
    return `${API_BASE_URL}${pathOrUrl}`;
  }
  return pathOrUrl;
}

function withQuery(url, query) {
  if (!query || typeof query !== 'object') return url;
  const u = new URL(url, window.location.origin);
  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    u.searchParams.set(k, String(v));
  });
  return u.toString();
}

async function delay(ms) {
  return new Promise(res => setTimeout(res, ms));
}

async function request(method, pathOrUrl, options = {}) {
  const {
    headers = {},
    body,
    query,
    signal,
    timeout = 15000,
    retry = 2,
  } = options;

  let url = resolveUrl(pathOrUrl);
  url = withQuery(url, query);

  const controller = new AbortController();
  let onAbort;
  if (signal) {
    // Link external signal to abort our controller too
    if (signal.aborted) {
      controller.abort();
    } else {
      onAbort = () => controller.abort();
      signal.addEventListener('abort', onAbort);
    }
  }

  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const defaultHeaders = {
    ...(API_KEY ? { 'X-API-KEY': API_KEY } : {}),
    ...(isFormData ? {} : body !== undefined ? { 'Content-Type': 'application/json' } : {}),
  };
  const finalHeaders = { ...defaultHeaders, ...headers };

  const finalInit = {
    method: method.toUpperCase(),
    headers: finalHeaders,
    signal: controller.signal,
    // Send the dashboard session cookie on every request (auth + RBAC endpoints).
    credentials: 'include',
    body: isFormData ? body : body !== undefined ? (typeof body === 'string' ? body : JSON.stringify(body)) : undefined,
  };

  let attempts = 0;
  // const start = Date.now();
  let timeoutId;
  if (timeout > 0) {
    timeoutId = setTimeout(() => controller.abort(), timeout);
  }
  try {
    // Retry loop
    // eslint-disable-next-line no-constant-condition
    while (true) {
      attempts += 1;
      try {
        const res = await fetch(url, finalInit);
        if (!res.ok) {
          // Retry on 5xx and 429
          if ((res.status >= 500 || res.status === 429) && attempts <= retry + 1) {
            const backoff = Math.min(2000, 300 * attempts);
            await delay(backoff);
            continue;
          }
        }
        return res;
      } catch (err) {
        // Network/abort errors: retry if timeouts/abort not intentional
        if (attempts <= retry + 1) {
          const backoff = Math.min(2000, 300 * attempts);
          await delay(backoff);
          continue;
        }
        throw err;
      }
    }
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
    if (signal && onAbort) {
      try {
        signal.removeEventListener('abort', onAbort);
      } catch (_) {
        // no-op: best-effort cleanup
      }
    }
  }
}

const client = {
  get: (url, opts) => request('GET', url, opts),
  post: (url, opts) => request('POST', url, opts),
  put: (url, opts) => request('PUT', url, opts),
  patch: (url, opts) => request('PATCH', url, opts),
  delete: (url, opts) => request('DELETE', url, opts),
};

export default client;


